module.exports = {"remoteServiceBaseUrl":"http://dev.lippo.homes:1001/","userManualBaseUrl":"http://103.106.81.48/PDFService","appBaseUrl":"http://localhost:4200","trackRewardUrl":"http://139.255.31.3:2001/LC_PersonalsM/rewards_bonus.php?ppno=","localeMappings":[{"from":"pt-BR","to":"pt"},{"from":"zh-CN","to":"zh"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/appconfig.json
// module id = ./src/assets/appconfig.json
// module chunks = main